import Vue from 'vue'
import VueGeolocation from 'vue-browser-geolocation';
Vue.use(VueGeolocation);

import Geocoder from "@pderas/vue2-geocoder";

Vue.use(Geocoder, {
    defaultCountryCode: 'AR', // e.g. 'CA'
    defaultLanguage:    'es', // e.g. 'en'
    defaultMode:        'lat-lng', // or 'lat-lng'
    googleMapsApiKey:   process.env.GOOGLE_MAPS_API_KEY
});